import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import RecoverAccountForm from "./RecoverAccountForm";
import EmailSentConfirmation from "./EmailSentConfirmation";
import AccountCreationLayout from "components/Accounts/Layouts/AccountCreationLayout";

export default function RecoverAccount() {
  const [emailConfirmation, setEmailConfirmation] = useState(null);

  return (
    <AccountCreationLayout>
      <Helmet>
        <title>U.GG - Recover Account</title>
      </Helmet>
      {emailConfirmation === null ? (
        <RecoverAccountForm setEmailConfirmation={setEmailConfirmation} />
      ) : (
        <EmailSentConfirmation emailConfirmation={emailConfirmation} setEmailConfirmation={setEmailConfirmation} />
      )}
    </AccountCreationLayout>
  );
}
